import { Goal, ID, UpdateGoal } from '@griply/types';
import { useCallback } from 'react';

import { useMergeGoalLinkChanges } from './use-merge-goal-link-changes';
import { useUpdateGoal } from './use-update-goal';

export type MoveGoalTarget = {
  parentIds: ID[];
  lifeAreaIds: ID[];
  archive?: boolean;
};

// Both link types live on one goal document, so their updates merge into a single write.
export const useMoveGoal = () => {
  const { submit: updateGoal } = useUpdateGoal();
  const mergeGoalLinkChanges = useMergeGoalLinkChanges();

  return useCallback(
    (goal: Goal, { parentIds, lifeAreaIds, archive }: MoveGoalTarget) => {
      const seed: UpdateGoal = {
        id: goal.id,
        ...(archive ? { archivedAt: new Date() } : {}),
      };

      mergeGoalLinkChanges([seed], {
        goalParentChanges: [{ goalId: goal.id, parentIds }],
        goalLifeAreaChanges: [{ goalId: goal.id, lifeAreaIds }],
      })
        // A move that changes neither link leaves the seed at its bare id — nothing to write.
        .filter((merged) => Object.keys(merged).length > 1)
        .forEach((merged) => updateGoal(merged, true));
    },
    [mergeGoalLinkChanges, updateGoal],
  );
};
